// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604280706/js/" + chunkId + "." + {"44":"fe83fdfa","225":"5a2ae3f3","481":"9a10c09b","486":"4659b4ef","770":"df13fffa"}[chunkId] + ".0.20542254617790956.chunk.js";
};